import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "I've never touched a camera or a timeline. Can I still join?",
    a: "Absolutely. Every program starts from the fundamentals and moves fast. What you need is commitment — the craft, the gear and the workflow are on us.",
  },
  {
    q: "Is the training online or in person?",
    a: "Fully in person. You train at Lime Studios — Life Inside Media's pro-grade studio floor in Pune — on real sets, with real crews, on live client productions.",
  },
  {
    q: "What happens after I graduate — do you help with jobs?",
    a: "Every long-term program comes with 100% placement assistance — plus a portfolio of real client work, a portfolio website and a career kit, so you're interviewing with proof, not promises.",
  },
  {
    q: "Do I need to bring my own gear?",
    a: "No. You'll train on cinema-line cameras and industry-standard edit suites at the studio. If you prefer your own system, you're welcome to bring it.",
  },
  {
    q: "Who actually teaches the sessions?",
    a: "Senior members of the Life Inside Media production team, direct mentorship from founder Amit Singh, and guest sessions from working industry professionals.",
  },
  {
    q: "How much does it cost?",
    a: "Fee structures are shared during your counselling call, once we know which program fits you. EMI plans are available, and scholarships are set aside for standout applicants.",
  },
  {
    q: "I'm in college or working. Can I manage both?",
    a: "Sessions are scheduled to be manageable alongside college or work — but expect real set hours. Live projects don't wait, and that's the point.",
  },
  {
    q: "Am I too old — or too young — for this?",
    a: "Neither. The programs are built for anyone serious about a career in film and video — students, working professionals and career-switchers alike.",
  },
];

export default function FaqSection() {
  return (
    <section className="bg-lima-ink px-5 md:px-10 py-14 md:py-32 border-t border-white/10" data-testid="faq-section">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-lima-paper leading-[0.98]">
            Questions,
            <br />
            <span className="font-serifit font-normal text-lima-blue">answered straight.</span>
          </h2>
          <p className="mt-6 max-w-sm text-sm text-white/50 leading-relaxed">
            Something else on your mind? Ask us directly through the enquiry form below.
          </p>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 30, filter: "blur(12px)" }}
          whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7"
        >
          <Accordion type="single" collapsible className="border-t border-white/10" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display font-bold text-lg md:text-xl tracking-tight text-lima-paper hover:text-lima-blue hover:no-underline py-6 transition-colors duration-200">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-white/60 leading-relaxed pb-6 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
